var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 23,
    viewBox: "0 0 46 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L11.3403 11.5799V22.8403H0V0Z",
    fill: "#25BA9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0416 23L33.7013 11.4201V0.159722H45.0416V23Z",
    fill: "#25BA9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5209 0H11.3403V11.5L22.5209 22.5208H33.7014V11.5L22.5209 0Z",
    fill: "#25BA9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlogo);
export default __webpack_public_path__ + "static/media/nlogo.ddfbc78aa36bf71fd10ced1f063f6649.svg";
export { ForwardRef as ReactComponent };